import { ViewModel,View, ViewGenerator, ViewModelMessage } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CompiledClass, GetEnumTranslationMessage, GetEnumTranslatorMessage } from "src/formBuilder/datamodel/classGenerator";
import { DataModel } from "src/formBuilder/datamodel/structure";
import { ServerConnection } from "src/server/serverConnection";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { Enum, IEnumTranslator, MediaSelector } from "uicomponents";
import  { FormExecutorView } from "./formExecutor-view"
import { distinct } from "src/common/utilities";


export class FormExecutionParameter{
    formId:string;
    formName:string;
}

export class FormExecutorViewModel extends WindowViewModel implements ITemplateSelector{
    public getTitle(): string {
        return this.formName;
    }
    constructor(parentViewModel: ViewModel,executionParameter?: FormExecutionParameter) {
        super(parentViewModel);
        if(executionParameter==null){
            executionParameter = new FormExecutionParameter();
            executionParameter.formId = '705e3bea-a9e2-486f-89e0-efca01a0de41';
            executionParameter.formName = "test";
        }
        this.isSelfLoading = true;
        this._loadingCount =0;
        this.formId = executionParameter.formId;
        this.formName =executionParameter.formName;
        this.templateSelector = this;
        this.templates = [];
        this._translators = new Map<string,Enum>();
        this._viewModelResolver = new Promise((resolve,reject)=>{
            this._viewModelResolverFunction = resolve;
        });
        this.loadForm();
    }

    private _viewModelResolver:Promise<ViewModel>;
    private _viewModelResolverFunction : any;
    GetDefaultView(): View <ViewModel> {
        return new FormExecutorView();
    }
    public getTypeId(): string {
        return "VM-944D0986-9F07-4724-A37B-2DA704DD426D"
    }

    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId;} private _formId: string;
    public set formName(v: string) { this._formName = v;this.title = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private templates : Template[];
    private dataModel : DataModel;
    
    public set isSelfLoading(v: boolean) { 
        this._isSelfLoading = v; 
        this.updateLoadingStatus();
    } public get isSelfLoading(): boolean { return this._isSelfLoading;} private _isSelfLoading: boolean;
    
    
    public set viewModel(v: ViewModel) { this._viewModel = v; } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    public set mainTemplateSelector(v: string) { this._mainTemplateSelector = v; } public get mainTemplateSelector(): string { return this._mainTemplateSelector;} private _mainTemplateSelector: string;
    public set templateSelector(v: ITemplateSelector) { this._templateSelector = v; } public get templateSelector(): ITemplateSelector { return this._templateSelector;} private _templateSelector: ITemplateSelector;
    
    public set popupTemplateSelector(v: string) { this._popupTemplateSelector = v; } public get popupTemplateSelector(): string { return this._popupTemplateSelector;} private _popupTemplateSelector: string;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    private _translators : Map<string,Enum>;
    private _loadingCount;

    getViewModel(): Promise<ViewModel> {
        if(this.viewModel!=null)
            return Promise.resolve(this.viewModel);
        return this._viewModelResolver;
    }
    

    private async generateTranslators(requests:string[][]){
        let processAndEnum = distinct(requests.map(x=>x.join("!!"))).map(x=>x.split("!!"));
        try {
            this.isLoading = true;
            let translationInfo = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetTranslations',{
                EnumInfo:processAndEnum.map(x=>{return {
                    ProcessId:x[0],
                    EnumName:x[1]
                }})
            });
            translationInfo.Processes.forEach(process => {
                process.Enums.forEach(enu => {
                    let translatorparam = enu.Values.map(x=>{
                        let param = new translationValueAndStrungMapping();
                        param.value = x.Value;
                        param.translation = x.Translation;
                        return param;
                    })
                    let translator = new GeneralTranslator(translatorparam);
                    this._translators.set(`${process.ProcessId.toLowerCase()}!!${enu.Name}`,translator);
                });
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public async loadForm(){
        try {
            this.isSelfLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetFormInfo',{
                FormId : this.formId
            });
            let formInfo = JSON.parse(result.FormInfo);
            let dataModel = new DataModel(this);
            dataModel.Parse(formInfo.DataModel);
            dataModel.generateClasses(this);
            this.dataModel = dataModel;
            let templates = formInfo.FormData.Templates;
            let translators = this.getAllRequiredTranslators(templates.map(t=>t.Html));
            await this.generateTranslators(translators);
            templates.forEach(t => {
                let template = new Template();
                template.name = t.Name;
                template.className = t.ClassName;
                let dataModelClass = this.dataModel.classes.filter(x=>x.name==t.ClassName)[0];
                let compiledClass = this.dataModel.GetCompliledClass(dataModelClass); 
                template.dataModelClass = compiledClass;
                template.isMain = t.IsMain;
                template.mediaType = t.MediaType ?? 0;
                let html : string = t.Html;
                html = html.replaceAll('data-b-comp-itemtemplateselector="','data-b-comp-importanthasselectorfunction="{Binding importanthasselectorfunction}"data-b-comp-itemtemplateselector="');
                template.html = html;
                template.htmlProto = ViewGenerator.CreatePrototype(html,'3169b9c8-8886-4885-8962-b197e3c391b4');
                this.templates.push(template);
            });

            let mainTemplates = this.templates.filter(x=>x.isMain==true)
            let mainViewModel = this.filterTemplateByMediaType(mainTemplates);
            this.mainTemplateSelector = `return "${mainViewModel.name}"`;
            let newInstance = mainViewModel.dataModelClass.__CreateNewInstance__(this);
            newInstance._Builder_TemplateSelector__ = this;
            this.viewModel = newInstance;
            this._viewModelResolverFunction(this.viewModel);

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isSelfLoading = false;
        }
    }
    getAllRequiredTranslators(t:string[]):string[][]{
        let result = [];
        t.forEach(x=>{
            let a = this.extractEnumTranslatorsRequests(x);
            result.push(...a);
            let b = this.extractEnumTranslationRequests(x);
            result.push(...b);
        });
        return result;
    }
    extractEnumTranslatorsRequests(html:string):string[][]{
        const upperLevelRegex = /{Binding\s*{([^}]*)},Converter:__GetEnumTranslator__[^}]*}/gm
        const innerRegex = /Static\s+([^,]+)/gm
        let matches = html.matchAll(upperLevelRegex);
        let result = [];
        for(const element of matches){
            let group = element[1];
            let innerMatches = group.matchAll(innerRegex);
            let singleResult = [];
            for(const innerElement of innerMatches){
                for(let i=1;i<innerElement.length;i++){
                    singleResult.push(innerElement[i]);
                }
            }
            result.push(singleResult);
        }
        return result;
    }
    extractEnumTranslationRequests(html:string):string[][]{
        const upperLevelRegex = /{Binding\s*{([^}]*)},Converter:__TranslateEnum__[^}]*}/gm
        const innerRegex = /Static\s+([^,]+)/gm
        let matches = html.matchAll(upperLevelRegex);
        let result = [];
        for(const element of matches){
            let group = element[1];
            let innerMatches = group.matchAll(innerRegex);
            let singleResult = [];
            for(const innerElement of innerMatches){
                for(let i=1;i<innerElement.length;i++){
                    singleResult.push(innerElement[i]);
                }
            }
            result.push(singleResult);
        }
        return result;
    }
    filterTemplateByMediaType(templates:Template[]):Template{
        try{
            let result = MediaSelector.GetObjectByMediaType({
                default : ()=> <any>templates.filter(x=>x.mediaType==0).at(0),
                landscapeDefault : ()=> <any>templates.filter(x=>x.mediaType==1).at(0),
                portraitDefault : ()=> <any>templates.filter(x=>x.mediaType==2).at(0),
                portraitPhone : ()=> <any>templates.filter(x=>x.mediaType==3).at(0),
                landscapePhone : ()=> <any>templates.filter(x=>x.mediaType==4).at(0),
                portraitTablet : ()=> <any>templates.filter(x=>x.mediaType==5).at(0),
                landscapeTablet : ()=> <any>templates.filter(x=>x.mediaType==6).at(0),
                portraitLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==7).at(0),
                landscapeLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==8).at(0),
                desktop : ()=> <any>templates.filter(x=>x.mediaType==9).at(0),
            },true);
            return <Template>result;
        }catch{
            return null;
        }
    }
    getTemplate(vm: ViewModel, selector: string) {
        let functionProto = Function(`a=function(vm){${selector}};return a;`);
        let executableFunction = functionProto();
        let name = executableFunction(vm);
        let foundTemplatesNoMedia = this.templates.filter(x=>x.name==name);
        let found = this.filterTemplateByMediaType(foundTemplatesNoMedia);
        if(found==null)
            return null;
        let foundTemplate = found;
        return foundTemplate.htmlProto;
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof NodeExecutorRequestShowingPopupMessage){
            return this.requestShowingPopup(msg.popup,false,{
                template : msg.template,
                width : msg.width,
                height : msg.height
            });
        }else if(msg instanceof GetEnumTranslatorMessage){
            let processId = msg.processId;
            let enumName = msg.enumName;
            return this._translators.get(`${processId.toLowerCase()}!!${enumName}`);
        }else if(msg instanceof GetEnumTranslationMessage){
            let processId = msg.processId;
            let enumName = msg.enumName;
            let translator = this._translators.get(`${processId.toLowerCase()}!!${enumName}`);
            return translator.translateValue(msg.value);
        }else if(msg instanceof StartLoadingMessage){
            this._loadingCount++;
            this.updateLoadingStatus();
        }else if(msg instanceof StopLoadingMessage){
            this._loadingCount--;
            this.updateLoadingStatus();
        }else if(msg instanceof RequestCloseFormExecutorMessage){
            this.close();
        }else{
            return super.handleMessage(msg);
        }
        
    }

    private updateLoadingStatus(){
        if(this._loadingCount>0){
            this.realSetLoading(true);
        }else if(this.isSelfLoading){
            this.realSetLoading(true);
        }else{
            this.realSetLoading(false);
        }
    }
    private _loadingTimeout;
    private realSetLoading(v:boolean){
        if(this._loadingTimeout){
            try{
                clearTimeout(this._loadingTimeout);
                this._loadingTimeout =null;
            }catch{}
        }
        if(v){
            this._loadingTimeout = setTimeout(() => {
                this.isLoading = v;
                console.log("done");
            }, 40);
        }else{
            this._loadingTimeout = setTimeout(() => {
                this.isLoading = v;
                console.log("done");
            }, 200);
        }
    }

    public popupChanging(popup:IPopup,autoHide:boolean,additionalInfo:any){
        this.popupWidth = additionalInfo?.width ?? "auto";
        this.popupHeight = additionalInfo?.height ?? "auto";
        this.popupTemplateSelector = additionalInfo?.template;
    }

    override async isRefreshAllowed():Promise<boolean>{
        let vm = await this.getViewModel();
        return vm['refresh']!=null;
    }
    async refresh(){
        let vm = await this.getViewModel();
        vm['refresh']();
    }
}

class Template{
    public name:string;
    public className:string;
    public dataModelClass : CompiledClass;
    public isMain:boolean;
    public html:string;
    public htmlProto : any;
    public mediaType : number;
}

export class NodeExecutorRequestShowingPopupMessage extends ViewModelMessage{
    public popup: IPopup;
    public template : any;
    public width:string;
    public height:string;    
}

class translationValueAndStrungMapping{
    value:number;
    translation : string;
}
class GeneralTranslator extends Enum implements IEnumTranslator{
    private _translationValues : Map<number,string>;
    constructor(values:translationValueAndStrungMapping[]) {
        super();
        this._translationValues = new Map<number,string>();
        values.forEach(x=>this._translationValues.set(x.value,x.translation));
        
        this.values = values.map(x=>x.value);
        this.translator = this;
    }
    GetString(value: any) {
        return this._translationValues.has(value) ? this._translationValues.get(value) : "";
    }
    
}

export class StartLoadingMessage extends ViewModelMessage{

}

export class StopLoadingMessage extends ViewModelMessage{

}


export class RequestCloseFormExecutorMessage extends ViewModelMessage{

}